import { WORK_ABSENCE } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(WORK_ABSENCE)
